export default __webpack_public_path__ + "static/media/main_2.1e77a364.png";